import { get } from "lodash"
import Tooltip from "components/material/tooltip"

export default function DisabledAction({ children }) {
  const text = get(children, "props.children", children)
  return <Tooltip title={`${text} is disabled since you do not have access to any risk model.`}>
    <span className="resource-action disabled">{text}</span>
  </Tooltip>
}
